import styled from "styled-components";
import PropTypes from "prop-types";

const StyledFlex = styled.div`
  display: flex;
  flex-direction: ${props => props.direction || "row"};
  align-items: ${props => props.align || "stretch"};
  justify-content: ${props => props.justify || "stretch"};
  flex-wrap: ${props => props.wrap};;
`

const Flex = ({ ...props}) => {
  return (
    <StyledFlex {...props} />
  );
};

export default Flex;

Flex.propTypes = {
  direction: PropTypes.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  align: PropTypes.oneOf(["stretch", "center", "flex-start", "flex-end", "baseline"]),
  justify: PropTypes.oneOf(["stretch", "center", "flex-start", "flex-end", "space-between", "space-around"]),
  wrap: PropTypes.oneOf(["nowrap", "wrap", "wrap-reverse"])
};